class WorkflowsController {
    init() {
        //console.log("workflows init!");
    }

    index() {
        // Table functionality now handled by modern Stimulus table controller
    }

    edit() {
        //console.log("workflows edit!");
    }
}

window.BC = window.BC || {};
window.BC.workflows = new WorkflowsController();